import orgContainer from '@Components/AppContainer';
import InnerComponent from '@Components/Home/OpenStockTransfers';

const OpenStockTransfers = () => ((orgContainer(InnerComponent)));

export default OpenStockTransfers;
